import { Link, Typography } from '@branchjs/neo-components';
import { ImageService } from 'client/js/main/services/ImageService/ImageService';
import { classes } from './ScreenEmptyBranchAccountApps.styles';

import React from 'react';
import AccountActions from 'client/js/main/actions/AccountActions';

export const ScreenEmptyBranchAccountApps = () => {
  const ownerEmail = window?.App?.context?.view?.ownerEmail;
  return (
    <div className={classes.container}>
      <div className={classes.box}>
        <img src={ImageService.getImageUrl('/static/images/app_access_required.svg')} />
        <Typography variant="h3">App access required</Typography>
        <Typography variant="body1">
          It looks like you haven't been provisioned access to any apps yet. To gain access, please contact your Branch
          Account Admin <span className={classes.emailHelperText}>{ownerEmail}</span>.
        </Typography>

        <Link onClick={AccountActions.logout} component="button" variant="body2" id="app__click-to-sign-out">
          Sign Out
        </Link>
      </div>
    </div>
  );
};

export default ScreenEmptyBranchAccountApps;
